import { connect } from 'react-redux';
import compose from '../../../../src/web/utils/react/compose';
import { getCompanyName } from '../../../../src/web/store/modules/company';
import { isEditingLayout } from '../../../../src/web/store/modules/pageBuilder';
import widget from '../../../../src/web/components/widgets/decorators/widget';
import PageBreadcrumbTrail from './Breadcrumbs';
import { NAME, ID } from './properties';

export default compose(
  connect((state) => {
    const { page, pageBuilder } = state;

    const pageId = (page && page.id) || (pageBuilder && pageBuilder.id);

    return {
      pageId: isEditingLayout(state) ? null : pageId,
      companyName: getCompanyName(state),
    };
  }),
  widget(
    { name: NAME, category: 'Breadcrumbs', componentId: ID },
    { menu: { items: ['delete'] } },
  ),
)(PageBreadcrumbTrail);
